import { metaService } from '../services'

const state = {
  all: {
    fortnoxActivationUrl: null
  }
}

const actions = {
  getMetaData ({ commit }) {
    return metaService.getMetaData().then(data => {
      commit('getMetaDataSuccess', data.result)
      return data.result
    })
  }
}
const mutations = {
  getMetaDataSuccess (state, data) {
    state.all = data
    console.log('Mutation: ' + state.all.fortnoxActivationUrl)
  }
}

export const meta = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/meta.module.js